import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41444838
const initialState: {
  order_id?: string
  client_secret?: string
  api_key?: string
  err_msg?: string
} = {}
export const stripe_get_ext_info = createAsyncThunk(
  '/live/pay/stp_get_ext_info',
  async (order_id: string, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/stp_get_ext_info',
      {
        ...store.getState().env.deviceinfo,
        order_id,
      }
    )
    return resp.data.data
  }
)

export const stripe_update_payment_intent = createAsyncThunk(
  '/live/pay/stp_update_payment_intent',
  async (
    data: {
      order_id: string
      payment_method_id: string
    },
    store
  ) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/stp_update_payment_intent',
      {
        ...store.getState().env.deviceinfo,
        ...data,
      }
    )
    return resp.data.data
  }
)
export const Wallet2StripeSlice = createSlice({
  name: 'Wallet2Stripe',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(stripe_get_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        order_id: action.meta.arg,
      })
    })
  },
})
export const Wallet2StripeSliceActions = Wallet2StripeSlice.actions
export default Wallet2StripeSlice.reducer
export const useWallet2StripeState = () => {
  const data = useSelector((state) => state.Wallet2Stripe)
  return data
}
